import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Button } from "@/lib/components/Button/Button";
import { IconChevronLeft, IconX } from "@tabler/icons-react";

export const DialogHeaderCenter = ({
  title,
  description,
  descriptionHidden = false,
  onBack,
}: {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  descriptionHidden?: boolean;
  onBack?: () => void;
}) => {
  return (
    <div className="relative flex w-full flex-col items-center px-8 pt-16">
      {!!onBack && (
        <Button
          variant="ghost"
          size="iconSm"
          onClick={onBack}
          className="absolute top-3 left-3 [&_svg]:size-5"
        >
          <IconChevronLeft />
        </Button>
      )}
      <DialogPrimitive.Close asChild>
        <Button
          variant="ghost"
          size="iconSm"
          className="absolute top-3 right-3"
        >
          <IconX />
          <span className="sr-only">Close</span>
        </Button>
      </DialogPrimitive.Close>
      <DialogPrimitive.Title className="text-center text-xl font-semibold">
        {title}
      </DialogPrimitive.Title>
      {description && (
        <DialogPrimitive.Description
          className="mt-1 text-center text-sm text-text-secondary"
          hidden={descriptionHidden}
        >
          {description}
        </DialogPrimitive.Description>
      )}
    </div>
  );
};
